import React, { useState } from "react";
import {  FaMinus, FaPlus,FaMicroscope, FaNotesMedical, FaDna, FaLaptopMedical, FaCapsules, FaBrain, FaClipboardList, FaFlask, FaVial, FaStethoscope, FaUserMd, FaUserCheck,  FaHospital, FaHandHoldingHeart, FaBookMedical } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/RegenerativeMedicine.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Stem Cell Therapy",
        "description":
          "Harness the power of stem cells to repair, regenerate, and replace damaged tissues and organs. Stem cell therapy is revolutionizing treatments for conditions such as spinal cord injuries, heart disease, autoimmune disorders, and neurodegenerative diseases like Parkinson’s and Alzheimer’s. By utilizing pluripotent or multipotent stem cells, this therapy promotes natural healing, reduces inflammation, and accelerates recovery with long-lasting effects."
    },
    {
        "title": "Tissue Engineering",
        "description":
          "Develop bioengineered tissues using biomaterials, cellular scaffolds, and growth factors to replace or support damaged biological structures. Tissue engineering plays a crucial role in regenerative medicine, offering solutions for burn victims through skin grafts, repairing cartilage in osteoarthritis patients, and creating lab-grown organs for transplantation. These innovations reduce dependency on donor organs and enhance the quality of life for patients requiring reconstructive procedures."
    },
    {
        "title": "Gene Therapy",
        "description":
          "Modify or replace defective genes to treat or prevent genetic disorders at their source. Gene therapy utilizes techniques such as CRISPR and viral vector delivery to correct genetic mutations linked to diseases like cystic fibrosis, sickle cell anemia, hemophilia, and certain types of cancer. This cutting-edge approach not only offers potential cures but also enables personalized treatments tailored to an individual’s genetic makeup."
    },
    {
        "title": "Platelet-Rich Plasma (PRP) Therapy",
        "description":
          "Utilize PRP injections, derived from a patient’s own blood, to accelerate healing and tissue regeneration. PRP therapy is widely used in orthopedics, sports medicine, and dermatology for treating tendon injuries, osteoarthritis, muscle tears, and post-surgical recovery. The growth factors present in PRP stimulate tissue repair, enhance collagen production, and promote faster wound healing, making it a popular non-invasive alternative to surgery."
    },
    {
        "title": "Cartilage & Joint Regeneration",
        "description":
          "Restore joint health through regenerative techniques, including mesenchymal stem cells, growth factors, and biomaterial scaffolds. These therapies provide long-term relief for osteoarthritis, sports injuries, and cartilage degeneration by regenerating damaged tissue, reducing inflammation, and delaying the need for joint replacement surgeries. Advanced techniques such as hydrogel implants and 3D-printed cartilage scaffolds are paving the way for minimally invasive joint repair solutions."
    },
    {
        "title": "Neuroregeneration",
        "description":
          "Develop advanced regenerative treatments aimed at restoring nerve function after spinal cord injuries, stroke, and neurodegenerative diseases like Parkinson’s and ALS. Cutting-edge approaches include stem cell transplantation, gene therapy for neuroprotection, neurotrophic factor delivery, and bioengineered nerve grafts. These therapies promote axonal regrowth, reduce neuronal loss, and enhance functional recovery, offering new hope for patients with previously untreatable neurological conditions."
    }
]

const features = [
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Cutting-edge stem cell research and applications." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Advanced laboratory testing for personalized treatment." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Expert regenerative medicine specialists and researchers." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Non-invasive and minimally invasive therapeutic options." },
    { icon: <FaHospital className="text-[#2a627a] text-lg" />, text: "Clinical trials for breakthrough regenerative treatments." },
    { icon: <FaHandHoldingHeart className="text-[#2a627a] text-lg" />, text: "Ethical and patient-centered regenerative care approaches." }
];

const benefits = [
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Speeds up recovery and promotes natural healing." },
    { icon: <FaVial className="text-[#2a627a] text-lg" />, text: "Reduces reliance on surgery and long-term medications." },
    { icon: <FaStethoscope className="text-[#2a627a] text-lg" />, text: "Offers personalized and targeted treatment plans." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Enhances treatment for chronic conditions and injuries." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Integrates with existing healthcare therapies and practices." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Supports advancements in regenerative medical research." }
];
const cmsFeatures = [
    { icon: <FaBrain className="text-[#2a627a] text-lg" />, text: "Stem Cell Scientist – Researches and develops stem cell therapies." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Regenerative Medicine Specialist – Diagnoses and treats using regenerative techniques." },
    { icon: <FaBookMedical className="text-[#2a627a] text-lg" />, text: "Biotech Engineer – Designs and optimizes regenerative medical devices." },
    { icon: <FaClipboardList className="text-[#2a627a] text-lg" />, text: "Clinical Research Coordinator – Manages regenerative medicine clinical trials." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Biomedical Scientist – Studies tissue engineering and regenerative treatments." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Healthcare Consultant – Advises on regenerative medicine applications and policies." }
];
const RMSCT = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex justify-center items-center"> Regenerative Medicine & Stem Cell Therapy  - <span className="text-gray-800"> HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        ""Advancing healing and recovery through cutting-edge regenerative medicine and stem cell therapies for personalized and restorative treatments"
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Regenerative Medicine & Stem Cell Therapy ?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Regenerative medicine is a groundbreaking field focused on repairing, regenerating, and replacing damaged tissues and organs using advanced techniques like stem cell therapy, gene editing, and tissue engineering. It offers new hope for chronic diseases, injuries, and age-related conditions.

Stem Cell Therapy utilizes pluripotent or adult stem cells to regenerate damaged tissues, helping patients with conditions like neurological disorders, heart disease, orthopedic injuries, and autoimmune diseases.

At HIKEHEALTH GS, we support cutting-edge regenerative medicine research, clinical applications, and biotech innovations to revolutionize patient care.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Regenerative Medicine & Stem Cell Therapy
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default RMSCT;
